<div class="search-container-details">
    <div class="tab-title-icon">
        <cll-icon class="tab-icon" type="outlined">assignment</cll-icon>
        <span class="detail-table-title">Active reports</span>
    </div>
    <div>

    </div>
</div>

<div class="tabs-table-container">
    <table class="cll-table">
        <thead>
        <tr>
            <th>Report name</th>
            <th>Description</th>
            <th></th>
        </tr>
        </thead>
        <tbody>
            <tr *ngFor="let report of testReportsData; let i = index">
                <td>{{ report.name }}</td>
                <td>{{ report.description }}</td>
                <td class="align-right">
                    <button cll-icon-button
                            [cllMenuTriggerFor]="menu"
                            (click)="$event.stopPropagation()">
                        <cll-icon>more_vert</cll-icon>
                    </button>

                    <ng-template #menu>
                        <cll-menu>
                            <button cllMenuItem
                                (click)="runReport(report.id)">
                                <cll-icon type="outlined">add</cll-icon>
                                 Run report
                            </button>
                        </cll-menu>
                    </ng-template>
                </td>
            </tr>
        </tbody>
    </table>
</div>
